import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { injectParams } from 'ngxtension/inject-params';

@Component({
  selector: 'app-enrollment-entry',
  template: '',
  standalone: false,
})
export class EnrollmentEntryComponent implements OnInit {
  private token = injectParams('token');
  private router = inject(Router);

  ngOnInit() {
    if (!this.token()) {
      this.router.navigate(['/pharmacy-enrollment/error']);
    } else {
      this.router.navigate(['/pharmacy-enrollment/', this.token()?.toLowerCase()]);
    }
  }
}
